import { Area } from './SearchSuggestionsTownsAndCities.types';

export const defaultToRentAreas: Area[] = [
    {
        id: 'in-the-city',
        headline: 'In the city',
        sub_headline: 'Live among the hustle and bustle',
        items: [
            {
                location: 'london',
                headline: 'London properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/london/'
            },
            {
                location: 'aberdeen',
                headline: 'Aberdeen properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/aberdeen/'
            },
            {
                location: 'edinburgh',
                headline: 'Edinburgh properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/edinburgh/'
            },
            {
                location: 'manchester',
                headline: 'Manchester properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/manchester/'
            },
            {
                location: 'liverpool',
                headline: 'Liverpool properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/liverpool/'
            },
            {
                location: 'cardiff',
                headline: 'Cardiff properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/cardiff/'
            }
        ]
    },
    {
        id: 'on-the-coast',
        headline: 'On the coast',
        sub_headline: 'Wake up to fresh air and sea views',
        items: [
            {
                location: 'swansea',
                headline: 'Swansea properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/swansea/'
            },
            {
                location: 'bristol',
                headline: 'Bristol properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/bristol/'
            },
            {
                location: 'hull',
                headline: 'Hull properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/hull/'
            },
            {
                location: 'southamptom',
                headline: 'Southampton properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/southampton/'
            },
            {
                location: 'plymouth',
                headline: 'Plymouth properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/plymouth/'
            },
            {
                location: 'dundee',
                headline: 'Dundee properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/dundee/'
            }
        ]
    },
    {
        id: 'rural-and-countryside',
        headline: 'Rural and countryside',
        sub_headline: 'Enjoy living close to nature',
        items: [
            {
                location: 'leicester',
                headline: 'Leicester properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/leicester/'
            },
            {
                location: 'northampton',
                headline: 'Northampton properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/northampton/'
            },
            {
                location: 'kent',
                headline: 'Kent properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/kent/'
            },
            {
                location: 'derby',
                headline: 'Derby properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/derby/'
            },
            {
                location: 'essex',
                headline: 'Essex properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/essex/'
            },
            {
                location: 'devon',
                headline: 'Devon properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/devon/'
            }
        ]
    },
    {
        id: 'popular-locations',
        headline: 'Popular locations',
        sub_headline: 'Move to a property hotspot',
        see_all_property: {
            link: 'https://www.zoopla.co.uk/to-rent/property/uk/',
            text: 'See all UK properties to rent'
        },
        items: [
            {
                location: 'glasgow',
                headline: 'Glasgow properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/glasgow/'
            },
            {
                location: 'birmingham',
                headline: 'Birmingham properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/birmingham/'
            },
            {
                location: 'nottingham',
                headline: 'Nottingham properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/nottingham/'
            },
            {
                location: 'sheffield',
                headline: 'Sheffield properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/sheffield/'
            },
            {
                location: 'coventry',
                headline: 'Coventry properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/coventry/'
            },
            {
                location: 'wolverhampton',
                headline: 'Wolverhampton properties to rent',
                url: 'https://www.zoopla.co.uk/to-rent/property/wolverhampton/'
            }
        ]
    }
];
